import { render, staticRenderFns } from "./storeSplitRecord.vue?vue&type=template&id=b7ae972e"
import script from "./storeSplitRecord.vue?vue&type=script&lang=js"
export * from "./storeSplitRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports